/**
 * Transportadoras (17 §3.1; 11 §A; D65). Cadastro da Fase 1, usado na compra (Fase 2).
 * Endereço de rastreio opcional; com o marcador {codigo}, vira link direto para o envio (Fase 2).
 */
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FunctionField,
  List,
  SimpleForm,
  SimpleList,
  TextField,
  TextInput,
  email,
  regex,
  required,
} from "react-admin";
import Grid from "@mui/material/Grid";
import { AcoesLista, BarraFormulario, EntradaTelefone, LinkWhatsapp, useCelular, vazioParaNulo } from "../componentes";
import { formatarTelefone } from "../lib/formato";
import { ConsultaCnpj } from "./fornecedores";

const validarRastreio = (valor: unknown) => {
  if (valor === null || valor === undefined || valor === "") return undefined;
  const t = String(valor);
  if (!/^https?:\/\//.test(t)) return "Informe o endereço completo, começando com https://";
  return undefined;
};
const validarSite = regex(/^https?:\/\/\S+$/, "Informe o endereço completo, começando com https://");

export function TransportadoraLista() {
  const celular = useCelular();
  return (
    <List title="Transportadoras" sort={{ field: "nome", order: "ASC" }} actions={<AcoesLista />} exporter={false}>
      {celular ? (
        <SimpleList primaryText={(r) => r.nome} secondaryText={(r) => r.contato ?? ""} tertiaryText={(r) => <LinkWhatsapp numero={r.whatsapp} />} linkType="edit" />
      ) : (
        <Datagrid bulkActionButtons={false} rowClick="edit">
          <TextField source="nome" />
          <TextField source="contato" emptyText="—" />
          <FunctionField source="whatsapp" render={(r) => <LinkWhatsapp numero={r.whatsapp} />} />
          <FunctionField source="telefone" render={(r) => (r.telefone ? formatarTelefone(r.telefone) : "—")} />
          <FunctionField source="url_rastreio" render={(r) => (r.url_rastreio ? "Configurado" : "—")} />
          <BooleanField source="ativo" />
        </Datagrid>
      )}
    </List>
  );
}

function CamposTransportadora() {
  return (
    <Grid container columnSpacing={2} sx={{ width: "100%" }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <ConsultaCnpj avisoSituacao="Confira antes de contratar." />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput source="nome" validate={required()} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput source="razao_social" parse={vazioParaNulo} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput source="contato" parse={vazioParaNulo} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <EntradaTelefone source="whatsapp" label="WhatsApp" fullWidth />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <EntradaTelefone source="telefone" fullWidth />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TextInput source="email" parse={vazioParaNulo} validate={email("E-mail inválido.")} fullWidth />
      </Grid>
      <Grid size={12}>
        <TextInput
          source="url_rastreio"
          parse={vazioParaNulo}
          validate={validarRastreio}
          fullWidth
          helperText="Opcional. Se a transportadora aceitar o código no endereço, use {codigo} (ex.: https://site.com.br/rastreio?c={codigo}); se não, informe só a página de rastreio."
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextInput source="site" parse={vazioParaNulo} validate={validarSite} fullWidth />
      </Grid>
      <Grid size={12}>
        <TextInput source="observacao" parse={vazioParaNulo} multiline fullWidth />
      </Grid>
      <Grid size={12}>
        <BooleanInput source="ativo" defaultValue={true} />
      </Grid>
    </Grid>
  );
}

export function TransportadoraCriar() {
  return (
    <Create title="Nova transportadora" redirect="list">
      <SimpleForm>
        <CamposTransportadora />
      </SimpleForm>
    </Create>
  );
}

export function TransportadoraEditar() {
  return (
    <Edit title="Editar transportadora" mutationMode="pessimistic" redirect="list">
      <SimpleForm toolbar={<BarraFormulario />}>
        <CamposTransportadora />
      </SimpleForm>
    </Edit>
  );
}
